import gsap from 'gsap';
import LazyLoad from 'vanilla-lazyload';
import marquee from 'vanilla-marquee';
import Flickity from 'flickity';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { Fancybox } from "@fancyapps/ui";
import inView from 'in-view';

gsap.registerPlugin(MotionPathPlugin);

const HTML = document.querySelector('html');

class App {
  constructor() {

    Fancybox.bind("[data-fancybox]", {
      // Your options go here
    });

    // Toggle menu
    const toggle = document.querySelector('.toggle-menu');
    if (toggle) {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        HTML.classList.toggle('open-menu')
      })
    }
    const nav = document.querySelector('.main-nav');
    if (nav) {
      nav.addEventListener('click', e => {
        if (!e.target.classList.contains('menu') && !e.target.closest('.menu')) {
          e.preventDefault();
          HTML.classList.remove('open-menu')
        }
      })

      const links = nav.querySelectorAll('a[href*="#"]');
      if (links) {
        links.forEach(link => {
          link.addEventListener('click', e => {
            HTML.classList.remove('open-menu')
          })
        })
      }
    }


    // Lazyload
    this.lazyload = new LazyLoad({
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: window.innerHeight * .8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest('figure');
          if (figure) figure.classList.add('media-is-loaded')
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest('figure');
        if (figure) figure.classList.add('media-is-loaded')
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Link anchor
    const anchors = document.querySelectorAll('a[href*="#"]');
    if (anchors) {
      anchors.forEach(anchor => {
        anchor.addEventListener('click', e => {
          const href = anchor.getAttribute('href').replace('/', '');
          if (href == "#") return;

          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            const pos = target.getBoundingClientRect();
            gsap.to(document.querySelectorAll('html, body'), { duration: 0.8, ease: 'expo.out', scrollTop: pos.y + window.scrollY })
          }
        })
      })
    }

    this.cloud();
    this.marquee();
    this.carousel();
    this.slider();
    this.map();
    this.inViewport();
  }

  inViewport() {
    // In viewport
    inView.offset(window.innerHeight * .15);
    inView('.js-reveal:not(.is-visible)')
      .on('enter', function (elt) {
        elt.dispatchEvent(new Event('inview'))
        elt.classList.add('is-visible');
        elt.classList.remove('not-visible');

        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != '') {
          elt.play();
        }
      })
      .on('exit', function (elt) {
        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != '') {
          elt.pause();
        }
        elt.dispatchEvent(new Event('outview'))
        elt.classList.add('not-visible');
      })
  }

  cloud() {
    const clouds = document.querySelectorAll('[data-cloud]');
    if (clouds) {
      clouds.forEach(cloud => {
        const speed = parseFloat(cloud.dataset.cloud);
        const bounding = cloud.getBoundingClientRect();
        const duration = 30 * Math.abs(speed);
        const w = window.innerWidth;

        const tlCloud = gsap.timeline({ paused: true, repeat: -1 });
        let start = 0;

        if (speed > 0) {
          start = ((bounding.x + bounding.width) / (w + bounding.width)) * duration
          tlCloud.fromTo(cloud, { left: `-${bounding.width}px` }, { duration: duration, left: `${100}%`, ease: 'none' })
        } else {
          start = duration - ((bounding.x + bounding.width) / (w + bounding.width)) * duration
          tlCloud.fromTo(cloud, { left: `100%` }, { duration: duration, left: `-${bounding.width}px`, ease: 'none' })
        }
        tlCloud.seek(start)

        cloud.closest('.js-reveal').addEventListener('inview', () => {
          tlCloud.play()
        })
        cloud.closest('.js-reveal').addEventListener('outview', () => {
          tlCloud.pause()
        })

      })
    }
  }

  marquee() {
    // Marquee
    const marquees = document.querySelectorAll('.marquee')
    if (marquees) {
      marquees.forEach((el, i) => {
        const m = new marquee(el, {
          direction: (i % 2 == 0 ? 'left' : 'right'),
          duplicated: true,
          startVisible: true,
          duration: (window.innerWidth * 0.05) * 1000
        })
        m.pause();

        el.closest('.js-reveal').addEventListener('inview', () => {
          m.resume();
        })
        el.closest('.js-reveal').addEventListener('outview', () => {
          m.pause();
        })
      })
    }
  }

  carousel() {

    //Carousel video
    const carouselVideos = document.querySelectorAll('.carousel-video');
    if (carouselVideos) {
      carouselVideos.forEach(carousel => {
        const flkty = new Flickity(carousel, {
          // options
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          lazyLoad: 4,
          pageDots: false
        });
      })
    }
  }

  slider() {

    //Slider
    const sliders = document.querySelectorAll('.carousel');
    if (sliders) {
      sliders.forEach(slider => {
        const flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          lazyLoad: 4,
          pageDots: false,
          on: {
            select: function () {
              const nbVisible = Math.round(this.size.width / this.slidesWidth)

              // Disable prev button
              if (this.selectedIndex == 0) {
                this.prevButton.element.classList.add('disabled')
                this.nextButton.element.classList.remove('disabled')
              }
              // Disable next button
              else if (this.selectedIndex + nbVisible >= this.cells.length) {
                this.nextButton.element.classList.add('disabled')
                this.prevButton.element.classList.remove('disabled')
              } else {
                this.nextButton.element.classList.remove('disabled')
                this.prevButton.element.classList.remove('disabled')
              }
            }
          }
        });


        const items = slider.querySelectorAll('.item')
        if (items) {
          items.forEach(item => {
            const cursor = item.querySelector('.cursor')

            item.addEventListener('mouseenter', e => {
              const bounding = item.getBoundingClientRect();
              item.addEventListener('mousemove', moveCursor)
              gsap.to(cursor, { scale: 1, duration: 0.3 });
            })
            item.addEventListener('mouseleave', e => {
              item.removeEventListener('mousemove', moveCursor)
              gsap.to(cursor, { scale: 0, duration: 0.3 })
            })
            function moveCursor(e) {
              const bounding = item.getBoundingClientRect();
              gsap.to(cursor, { duration: 0.05, left: e.clientX - bounding.x, top: e.clientY - bounding.y })
            }
          })
        }
      })
    }
  }

  map() {
    const maps = document.querySelectorAll('.map');
    if (maps) {
      maps.forEach(map => {
        const triggers = map.querySelectorAll('[data-target]');
        const popups = map.querySelectorAll('[data-popup]');

        if (popups) {
          popups.forEach(popup => {
            const anim = popup.querySelector('.anim')
            // if (anim) {
            //   const tl = gsap.timeline({ paused: true, repeat: -1, repeatDelay: 2 })
            //   const van = anim.querySelector('.van')

            //   tl
            //     .fromTo(anim, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, 'start')
            //     .to(van, {
            //       duration: 5,
            //       ease: "power2.in",
            //       motionPath: {
            //         path: anim.querySelector('.move'),
            //         align: anim.querySelector('.move'),
            //         autoRotate: false,
            //         alignOrigin: [0.5, 0.5]
            //       }
            //     }, 'start')
            //     .to(van, { autoAlpha: 0, duration: 0.3 }, '-=0.1')
            //     .to(anim, { autoAlpha: 0 }, '+=1')

            //   popup.anim = tl;
            // }

            popup.addEventListener('click', e => {
              if (!e.target.classList.contains('popup-content') && !e.target.closest('.popup-content')) {
                popup.classList.remove('show')
                HTML.classList.remove('no-scroll')
              }
            })

            const close = popup.querySelector('.trigger-close')
            if (close) {
              close.addEventListener('click', e => {
                e.preventDefault()
                popup.classList.remove('show')
                HTML.classList.remove('no-scroll')
              })
            }
          })
        }

        if (triggers) {
          triggers.forEach(el => {
            el.addEventListener('click', e => {
              e.preventDefault();
              const target = document.querySelector(`[data-popup="${el.dataset.target}"]`);
              if (target) {
                target.classList.add('show');
                HTML.classList.add('no-scroll')

                if (target.anim) {
                  setTimeout(() => {
                    target.anim.seek(0).play();
                  }, 1000)
                }
              }
            })
          })
        }
      })
    }


    const popups = document.querySelectorAll('.popup-event');
    if (popups) {
      popups.forEach(el => {
        const carousel = el.querySelector('.carousel-popup')

        const flkty = new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          lazyLoad: 4,
          pageDots: false,
          on: {
            select: function () {
              const nbVisible = Math.round(this.size.width / this.slidesWidth)

              if (this.cells.length <= nbVisible) {
                this.prevButton.element.remove();
                this.nextButton.element.remove();
              } else {

                // Disable prev button
                if (this.selectedIndex == 0) {
                  this.prevButton.element.classList.add('disabled')
                  this.nextButton.element.classList.remove('disabled')
                }
                // Disable next button
                else if (this.selectedIndex + nbVisible >= this.cells.length) {
                  this.nextButton.element.classList.add('disabled')
                  this.prevButton.element.classList.remove('disabled')
                } else {
                  this.nextButton.element.classList.remove('disabled')
                  this.prevButton.element.classList.remove('disabled')
                }
              }
            }
          }
        })
      })
    }
  }
}


window.addEventListener('DOMContentLoaded', () => {
  new App();
})